import classnames from "classnames";
import { Modal } from "../../Modal";
import UncheckedIcon from "../../../public/icon/unchecked2.svg";
import CheckedIcon from "../../../public/icon/checked2.svg";
import EyeIcon from "../../../public/icon/icon-eye.svg";
import Button from "../../UI/Button";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import { ScrollView } from "../../UI/ScrollView";
import { BootstrapInput } from "../../UI/BootstrapInput";

const Content = ({ className = "", ...restProps }) => {
  const { t } = useTranslation("nftauth");
  return (
    <div className="relative mb-[32px]">
      <ScrollView
        className={classnames("h-[210px] overflow-auto", className)}
        {...restProps}
      >
        <div className="pr-[8px] pb-[24px] text-[14px] leading-[20px] font-medium text-left">
          <div className="whitespace-pre-wrap">
            1. 活动期间
            <br />
            报名开始时间：2022.08.15 18:00 (UTC+8)
            <br />
            报名截止时间：2022.08.18 11:00 (UTC+8)
            <br />
            开奖时间：2022.08.18 18:00 (UTC+8)
            <br />
            <br />
            2. 活动参与方式
            <br />
            1) 持有CheersUP的CUP
            holder，可以在本活动报名截止前填写好友在合作平台的个人账号，好友账号将有机会获得“干杯！故宫”的空投资格。CUP的酿造时间越久，替好友账号获得空投的机会越高
            <br />
            2) 每个CUP holder
            在报名截止前仅可填写一次好友账号，且好友账号需满足合作平台的奖品获取要求（完成合作平台实名认证、年满18周岁且为中国大陆居民）。
            <br />
            3)
            为了提供本次活动，CryptoNatty需要向合作平台提供您主动填写的好友账号，我们承诺会自行并要求合作平台保护您好友的个人隐私，仅限本次活动使用。
            <br />
            <br />
            3. 活动奖品
            <br />
            合作平台提供的20个“干杯！故宫”空投资格。“干杯！故宫”数字藏品详见https://b23.tv/CA3lmvG
            <br />
            <br />
            4. 奖品发放
            <br />
            1)
            CryptoNatty将在报名截止后清除异常活动数据，并将获奖CUP填写的好友账号提交给合作平台用于发放空投资格。
            <br />
            2)
            合作平台将在收到账号后审核账号是否符合空投条件，不符合合作平台要求账号将被取消空投资格，且合作平台有权自行处理未发放的活动奖品。
            <br />
            3) 为好友获得空投资格的CUP
            holder名单将在开奖时间于Discord社区公示，所有活动奖品将在2022.08.19由合作平台自动发放至符合要求的空投账号中，请获奖的CUP及时通知好友。
            <br />
            <br />
            5. 注意事项及平台声明
            <br />
            1）
            CryptoNatty依法主办本活动 ，并有权根据法律法规、所在地区国家政策、行业规范、合作平台经营策略的变化调整，单方变更、中止、终止本活动，并在相关页面进行公布，CryptoNatty无须为此承担任何责任。
            <br />
            2）
            因不可抗力及不可归责于CryptoNatty的原因，导致您无法参与本活动或参与失败的，CryptoNatty无须为此承担任何责任。
            <br />
            3） 活动期间，因CUP
            holder自身原因（包括但不限于操作不当、错过活动时间、未填写正确的好友账号等）导致无法参与本活动或参与失败的，CryptoNatty无须为此承担任何责任。
            <br />
            4）
            如您对本活动有任何问题，可以通过CryptoNatty官方twitter联系CryptoNatty。 
            <br />
            <br />
            6. 特别注意
            <br />
            1） CUP holder及其好友不得以不正当手段或舞弊行为参与本活动。
            <br />
            2） CUP
            holder及其好友不得在活动期间违反法律法规、CryptoNatty或合作平台规则和本活动规则。
            <br />
            3） 如我们发现或接举报后发现CUP holder
            或其好友存在以上任意一种情况，一经查实，我们有权采取包括但不限于取消CUP
            holder及其好友的参与资格、取消奖励、追回已发放奖励等措施。
            <br />
            4） 请CUP
            holder通过CryptoNatty官方网站及CryptoNatty官方指定途径参与本次活动。CryptoNatty无须对非经CryptoNatty指定途径参与本活动的用户，或非经CryptoNatty
            官方名义发布的信息承担任何义务或责任。
          </div>
        </div>
      </ScrollView>
      <div className="absolute bottom-[-2px] w-[328px] h-[24px] bg-gradient-to-t from-[#fff] to-[rgba(255, 255, 255, 0.0001)]"></div>
    </div>
  );
};

const Step1 = ({ checked, setChecked, nftauthT, onConfirm }) => {
  const confirmDisabled = !checked;

  return (
    <div>
      <div className="text-[24px] leading-[32px] font-['DIN_Alternate'] mb-[16px]">
        {nftauthT("t22")}
      </div>
      <Content />
      <div className="flex justify-between h-[40px]">
        <Button
          variant="contained"
          color="secondary"
          component="span"
          className={classnames(
            "w-full h-full rounded-full transition font-medium",
            confirmDisabled
              ? "bg-[#F1F2F3] text-[#C9CCD0]"
              : "text-white hover:opacity-80"
          )}
          onClick={onConfirm}
          disabled={confirmDisabled}
        >
          <span>{nftauthT("t9")}</span>
        </Button>
      </div>
      <div className="flex justify-center items-center mt-[24px]">
        <button
          onClick={() => {
            setChecked(!checked);
          }}
          className="mt-[4px] btn-unstyled font-medium text-[12px] flex items-center text-[#484C53]"
        >
          {checked ? (
            <CheckedIcon className="w-[16px]" />
          ) : (
            <UncheckedIcon className="w-[16px]" />
          )}
          <div className="ml-[8px]">{nftauthT("t10")}</div>
        </button>
      </div>
    </div>
  );
};

const Step2 = ({ nftauthT, onConfirm }) => {
  const [uid, setUid] = useState("");

  console.log(nftauthT("t27"));

  return (
    <div>
      <div className="text-[24px] leading-[32px] font-['DIN_Alternate'] mb-[16px]">
        {nftauthT("t11")}
      </div>
      <BootstrapInput
        className="w-[336px] h-[48px] px-[16px] rounded-[8px] text-[16px] mt-[32px]"
        placeholder={nftauthT("t12")}
        value={uid}
        onChange={(event) => {
          setUid(event.target.value);
        }}
      />
      <div className="mt-[20px] text-left">
        {nftauthT("t21")
          .split("\n")
          .map((str, i) => {
            return (
              <div className="flex item-start mb-[16px] last:mb-[48px]" key={i}>
                <div className="w-[8px] min-w-[8px] h-[8px] rounded-full bg-[#E3E5E7] mr-[12px] mt-[5px]"></div>
                <div className="text-[12px] font-light text-[#61666D] leading-[20px]">
                  {str}
                </div>
              </div>
            );
          })}
      </div>
      <Button
        variant="contained"
        color="secondary"
        component="span"
        className={classnames(
          "w-full h-full rounded-full transition font-medium",
          "text-white hover:opacity-80"
        )}
        onClick={() => {
          onConfirm(uid);
        }}
      >
        <span>{nftauthT("t13")}</span>
      </Button>
    </div>
  );
};

export const ConfirmModal = ({ className = "", onUidConfirm, onCancel }) => {
  const [checked, setChecked] = useState(false);
  const { t: nftauthT } = useTranslation("nftauth");
  const [step, setStep] = useState(1);

  const confirm = () => {
    setStep(2);
  };

  return (
    <Modal
      className={classnames(
        "w-[416px] rounded-[48px] overflow-hidden p-[40px] pt-[48px] text-center",
        className
      )}
      onClose={onCancel}
    >
      <div className="mb-[32px]">
        <EyeIcon />
      </div>
      {step === 1 && (
        <Step1
          nftauthT={nftauthT}
          checked={checked}
          setChecked={setChecked}
          onConfirm={confirm}
        />
      )}
      {step === 2 && <Step2 nftauthT={nftauthT} onConfirm={onUidConfirm} />}
    </Modal>
  );
};
